var composeXmlHead = function composeXmlHead(body) {
  return "<!DOCTYPE fcpxml>\n\n<fcpxml version=\"1.8\">\n".concat(body, "\n</fcpxml>");
};

var composeXmlResources = function composeXmlResources(assets) {
  return "<resources>\n        ".concat(assets, "\n</resources>");
};
/**
 * 
 * @param {string} asset.id - r1
 * @param {string} asset.src - file:///clipName.mp4
 * @param {string} asset.start - s0
 * @param {string} asset.duration - 10s
 * @param {int} asset.hasVideo - 1
 * @param {int} asset.hasAudio - 1
 * @param {string} asset.format  - r2
 * @param {int} asset.audioSources - 1
 * @param {int} asset.audioChannels - 2
 *  @param {int} asset.audioRate - 48000
 * @param {object} asset.formatData 
 * @param {string} asset.formatData.id  - r2
 * @param {string} asset.formatData.formatName  - FFVideoFormat720p25
 */


var composeAsset = function composeAsset(_ref) {
  var id = _ref.id,
      src = _ref.src,
      start = _ref.start,
      duration = _ref.duration,
      _ref$hasVideo = _ref.hasVideo,
      hasVideo = _ref$hasVideo === void 0 ? 1 : _ref$hasVideo,
      _ref$hasAudio = _ref.hasAudio,
      hasAudio = _ref$hasAudio === void 0 ? 1 : _ref$hasAudio,
      formatId = _ref.formatId,
      _ref$audioSources = _ref.audioSources,
      audioSources = _ref$audioSources === void 0 ? 1 : _ref$audioSources,
      _ref$audioChannels = _ref.audioChannels,
      audioChannels = _ref$audioChannels === void 0 ? 2 : _ref$audioChannels,
      formatData = _ref.formatData,
      _ref$audioRate = _ref.audioRate,
      audioRate = _ref$audioRate === void 0 ? 48000 : _ref$audioRate;
  return "  <asset id=\"".concat(id, "\" src=\"").concat(src, "\" start=\"").concat(start, "s\" duration=\"").concat(duration, "s\" hasVideo=\"").concat(hasVideo, "\" hasAudio=\"").concat(hasAudio, "\" format=\"").concat(formatId, "\" audioSources=\"").concat(audioSources, "\" audioChannels=\"").concat(audioChannels, "\" audioRate=\"").concat(audioRate, "\"/>\n  ").concat(composeFormat(formatData));
};
/**
* @param {*} id - r2
 * @param {*} name - FFVideoFormat720p25
 */


var composeFormat = function composeFormat(_ref2) {
  var id = _ref2.id,
      _ref2$formatName = _ref2.formatName,
      formatName = _ref2$formatName === void 0 ? 'FFVideoFormat720p25' : _ref2$formatName;
  return "<format id=\"".concat(id, "\" name=\"").concat(formatName, "\"/>");
};
/**
 * 
 * @param {*} sequenceFormatId - r2 
 */


var composeSequence = function composeSequence(_ref3) {
  var eventName = _ref3.eventName,
      projectName = _ref3.projectName,
      _ref3$sequenceFormatI = _ref3.sequenceFormatId,
      sequenceFormatId = _ref3$sequenceFormatI === void 0 ? 'r2' : _ref3$sequenceFormatI,
      assetClips = _ref3.assetClips;
  return " <library>\n <event name=\"".concat(eventName, "\">\n     <project name=\"").concat(projectName, "\">\n         <sequence format=\"").concat(sequenceFormatId, "\">\n             <spine>\n                 ").concat(assetClips, "\n             </spine>\n         </sequence>\n     </project>\n     <!-- optionally if want to show clips used in the project event, under the sequence/compound clip - could add those here too -->\n     <!-- Clips -->\n     <!-- <asset-clip name=\"Basically, we're pretty happy with it - W1A - Series 3 Episode 3 Preview - BBC Two-ONWNWBoqTuM\" ref=\"r1\" format=\"r2\" duration=\"5s\" audioRole=\"dialogue\"/> -->\n     </event>\n</library>");
};

var composeAssetClip = function composeAssetClip(_ref4) {
  var clipName = _ref4.clipName,
      ref = _ref4.ref,
      start = _ref4.start,
      duration = _ref4.duration,
      _ref4$audioRole = _ref4.audioRole,
      audioRole = _ref4$audioRole === void 0 ? 'dialogue' : _ref4$audioRole;
  // if offset present then calculate offset - have offset default to zero if not provided
  return "<asset-clip name=\"".concat(clipName, "\" ref=\"").concat(ref, "\" start=\"").concat(start, "s\" duration=\"").concat(duration, "s\" audioRole=\"").concat(audioRole, "\"/>");
};

var jsonToFCPX = function jsonToFCPX(sequenceEDLJson) {
  var counterIdAssetClips = 1; // sequenceEDLJson.events 

  var assetClips = sequenceEDLJson.events.map(function (event, index) {
    var results = composeAssetClip({
      clipName: event.clipName,
      ref: "r".concat(counterIdAssetClips),
      start: event.startTime,
      duration: event.endTime - event.startTime
    });
    counterIdAssetClips = counterIdAssetClips + 2;
    return results;
  });
  var sequence = composeSequence({
    eventName: sequenceEDLJson.title,
    projectName: sequenceEDLJson.title,
    assetClips: assetClips.join('\n')
  });
  var counterId = 1;
  var assets = sequenceEDLJson.events.map(function (event, index) {
    var results = composeAsset({
      id: "r".concat(counterId),
      src: event.clipName,
      start: event.startTime,
      duration: event.endTime - event.startTime,
      // hasVideo = 1, 
      // hasAudio = 1, 
      formatId: "r".concat(counterId + 1),
      // audioSources = 1, 
      // audioChannels = 2, 
      formatData: {
        id: "r".concat(counterId + 1),
        name: "FFVideoFormat1080p".concat(event.fps)
      } // audioRate = 48000

    });
    counterId = counterId + 2;
    return results;
  });
  var resources = composeXmlResources(assets.join('\n'));
  var result = composeXmlHead(resources + sequence);
  return result;
};

module.exports = jsonToFCPX;